<script>
export default {
  data() {
    return {
      paymentType: "credit",
      payment_types: [
        {
          type: "credit",
          img:
            "/img/2540ac6aa913b81e75be9dad1374fe70.gif",
          fee:(price) => {
            //securion fee 3%
            return this.formatNumber(price * 0.03);
          },
          feeString: "3%",
          priceFromTotal(total) {
            let p = total / 1.03;
            if (p < 10) return 10;
            return p;
          },
          pay(self) {
            self.securionPayBuyTokens(self.current_total);
          },
        },
        {
          type: "paypal",
          img:
            "https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_150x38.png",
          fee: (price) => {
            //paypal fee 4.9% + $0.30
            return this.formatNumber((price * 0.049) + 0.3);
          },
          feeString: "4.9% + $0.30",
          priceFromTotal(total) {
            let p = (total - 0.3) / 1.049;
            if (p < 10) return 10;
            return p;
          },
          pay(self) {
            self.$store.dispatch("Payment/sendToPaypal", self.current_total)
          },
        },
        {
          type: "wire",
          img:
            "data:image/png;base64,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",
          fee() {
            //wire transfer fee $20
            return 20;
          },
          feeString: "$20",
          priceFromTotal(total) {
            let p = total - 20;
            if (p < 10) return 10;
            return p;
          },
          pay(self) {
            self.$router.push({
              name: "wiretransfer",
              params: {
                type: "banktransfer",
                price: self.tokenPackage.price,
                fee: self.current_fee,
                total: self.current_total,
              },
            });
          },
        },
        {
          type: "paxum",
          img:
            "data:image/png;base64,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",
          fee() {
            //paxum fee $1
            return 1;
          },
          feeString: "$1",
          priceFromTotal(total) {
            let p = total - 1;
            if (p < 10) return 10;
            return p;
          },
          pay(self) {
            self.package_title = self.getTrans(
              "messages." + self.tokenPackage.name + "_package"
            );
            // Need this to wait till all stack will be done (title and price will be applied).
            document.getElementById("paxum-price").value = self.current_total;
            setTimeout(() => {
              document.getElementById("paxum-form").submit();
            });
          },
        },
      ],
    };
  },
  computed: {
    current_payment_type() {
      try {
        return this.payment_types.find((p) => {
          return p.type == this.paymentType;
        });
      } catch (e) {
        return this.payment_types[0];
      }
    },
    current_fee() {
      return this.current_payment_type.fee(this.tokenPackage.price);
    },
    current_total() {
      return (
        Number.parseFloat(this.current_payment_type.fee(this.tokenPackage.price)) +
        Number.parseFloat(this.tokenPackage.price)
      );
    },
    current_token_package() {
      return this.tokenPackage ? this.tokenPackage : this.createcustomPackage();
    },
  },
  methods: {
    securionPayBuyTokens(price) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('Payment/sendSecurionPay', price)
          .then((response) => {
                                /* eslint-disable-next-line */
            SecurionpayCheckout.open({
              checkoutRequest: response.data.response,
              image: "../../img/apple-touch-icon.png",
              key: process.env.VUE_APP_SECURIONPAY_PUBLIC_KEY,
              name: "DivaTraffic",
              description: this.getTrans("messages.payment_tokens"),
              email: this.getUser,
            });
            /* eslint-disable-next-line */
            SecurionpayCheckout.success = (result) => {
              this.$store.dispatch('Payment/securionConfirm', result.charge.id)
                .then((data) => {
                  if (data.result == false) {
                    this.$swal.fire({
                      icon: "error",
                      text: this.getTrans("messages.payment_declined"),
                    }).then(() =>
                      reject(this.getTrans("messages.payment_declined"))
                    );
                  } else {
                    this.$swal.fire({
                      icon: "success",
                      text: this.getTrans("messages.tokens_added_to_account"),
                    }).then(() => {
                      resolve();
                      this.$store.dispatch("User/refresh");
                    });
                    resolve();
                  }
                })
                .catch((error) => {
                  if (typeof error.response.data.error.message == "object") {
                    this.$swal.fire({
                      title: this.getTrans("messages.something_went_wrong"),
                      html: Object.values(
                        error.response.data.error.message
                      ).join("<br />"),
                      icon: "error",
                      allowOutsideClick: false,
                    });
                  } else {
                    this.$swal.fire({
                      title: this.getTrans("messages.something_went_wrong"),
                      text: error.response.data.error.message,
                      icon: "error",
                      allowOutsideClick: false,
                    });
                  }
                  reject();
                });
            };
            /* eslint-disable-next-line */
            SecurionpayCheckout.error = function (error) {
              this.$swal.fire({
                title: this.getTrans("messages.payment failed"),
                html: Object.values(error.response).join("<br />"),
                icon: "error",
                allowOutsideClick: false,
              });
              reject(error);
            };
          })
          .catch((error) => {
            this.displayError(error);
            reject();
          });
      });
    },
    displayError(error) {
      if (typeof error?.response?.data?.error?.message == 'object') {
        this.$swal.fire({
          icon: 'error',
          title: this.getTrans('messages.something_went_wrong'),
          html: Object.values(error.response.data.error.message).join('<br />'),
          allowOutsideClick: false
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: this.getTrans('messages.something_went_wrong'),
          text: this.getTrans('extra.server_error_details'),
          allowOutsideClick: false
        });
      }
    },
    formatNumber(sum) {
      try {
        if (typeof sum === typeof 1 || Number.parseFloat(sum)) {
          return Number.parseFloat(sum).toLocaleString("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        }
      }
      /* eslint-disable-next-line no-empty */
      catch {}
      return '$-'
    },
  },
};
</script>
